import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { PlatformLocation, isPlatformServer, isPlatformBrowser } from '@angular/common';
import { EncrDecrService } from '../services/encr-decr.service';

@Injectable({ providedIn: 'root' })
export class RechargeService {
    loginType = "B2C"; private baseURL: any = ''; private encryptPassword: any = environment.encryptPassword; public systemsetup: any = {};
    constructor(@Inject(PLATFORM_ID) private platformId: Object, private http: HttpClient, platformLocation: PlatformLocation, private EncrDecr: EncrDecrService) {
        if (isPlatformBrowser(this.platformId)) this.baseURL = (platformLocation as any).location.origin;
    }

    getDecrypt(Data) {
        try {
            var encryptData = Data;
            var resp = window.atob(encryptData);
            encryptData = JSON.parse(resp);
        }
        catch (errormsg) {
            console.log(errormsg);
        }
        return encryptData;
    }

    getdecryptData(encryptStr) {
        var encryptData = this.EncrDecr.get(environment.encryptPassword, encryptStr.split(' ').join('+'));
        return encryptData;
    }


    getSetupData() {
        var encryptData = "";
        this.systemsetup = localStorage.getItem("merchantData");
        try {
            encryptData = (this.getdecryptData(this.systemsetup));
            this.systemsetup = JSON.parse(JSON.parse(encryptData).merchantsetup);
        }
        catch (errormsg) {
            try { this.systemsetup = JSON.parse(localStorage.getItem("merchantData")); } catch (error) { this.systemsetup = ""; }
        }
        return this.systemsetup;
    }

    getMerchantSetup(pgName?) {
        var data = this.baseURL;
        var dataf = data + "^&*" + "merchantSetup";

        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var encryptData = this.EncrDecr.set(environment.encryptPassword, dataf);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    getdecryptDataSSO(encryptStr) {
        var encryptData = this.EncrDecr.getHex(environment.encryptPassword, encryptStr.split(' ').join('+'));
        return encryptData;
    }

    getdashboardDecrypt() {
        try {
            var encryptData = JSON.parse(sessionStorage.getItem("logindata"));
            var resp = this.getdecryptData(encryptData);
            encryptData = JSON.parse(resp).cruisedashboard;
        }
        catch (errormsg) {
            console.log(errormsg);
        }
        return encryptData;
    }

    getloginEncrypt(loginname, param1?, methodname?) {
        var data = loginname + "^&*" + param1 + "^&*" + this.baseURL + "^&*" + methodname;
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);

        var url = environment.baseUrl;
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        return this.http.post(url, { "searchData": encryptData }, { headers: headers });
    }

    getreportsDecrypt() {
        try {
            var encryptData = JSON.parse(sessionStorage.getItem("logindata"));
            var resp = this.getdecryptData(encryptData);
            encryptData = JSON.parse(resp).cruisereports;
        }
        catch (errormsg) {
            console.log(errormsg);
        }
        return encryptData;
    }

    getAgentDecrypt() {
        try {
            var encryptData = JSON.parse(sessionStorage.getItem("logindata"));
            var resp = this.getdecryptData(encryptData);
            encryptData = JSON.parse(resp).agentdata;
        }
        catch (errormsg) {
            console.log(errormsg);
        }
        return encryptData;
    }

    fetchactivationplans(BillerID, Circle, logintype, agentcode, agentid, param1, methodname) {
        var data = BillerID + "()" + Circle + "()" + logintype + "()" + agentcode + "()" + agentid + "()" + "" + "()" + "" + "()^&*" + param1 + "^&*" + this.baseURL + "^&*" + methodname;
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);

        var url = environment.rechargeUrl + "/rechargeProcess";
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        return this.http.post(url, { "searchData": encryptData }, { headers: headers });
    }

    rechargePlan(BillerID, Circle, logintype, agentcode, agentid, param1, methodname) {
        var data = BillerID + "()" + Circle + "()" + logintype + "()" + agentcode + "()" + agentid + "()" + "" + "()" + "" + "()^&*" + param1 + "^&*" + this.baseURL + "^&*" + methodname;
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);

        var url = environment.rechargeUrl + "/rechargeProcess";
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        return this.http.post(url, { "searchData": encryptData }, { headers: headers });
    }

    getrechargeOffers(cruise, cruiseline, loginType) {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var data = cruise + '()' + cruiseline + "()" + loginType + '^&*Get^&*' + this.baseURL + '^&*cruiseexternallinks';
        var url = environment.baseUrl;
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(url, { "searchData": encryptData }, { headers: headers });
    }

    makeFinalSubmission(data) {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var url = environment.rechargeUrl + "/rechargeProcess";
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(url, { "searchData": encryptData }, { headers: headers });
    }

    
    getSIMMarkup(sid, uid, type, category, searchagentID, param1, methodname, param2?) {
        if (param1 == "GET") {
            var data = sid + "~" + uid + "~" + type + "~" + category + "~" + searchagentID + "~^&*" + param1 + "^&*" + this.baseURL + "^&*" + methodname;
        }
        if (param1 == "Edit") {
            var data = sid + "~" + uid + "~" + type + "~" + category + "~" + searchagentID + "~" + param2 + "~^&*" + param1 + "^&*" + this.baseURL + "^&*" + methodname;
        }
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);

        var url = environment.rechargeUrl + "/rechargeProcess";
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        return this.http.post(url, { "searchData": encryptData }, { headers: headers });
    }

}